export default "__VITE_ASSET__d45eb362__"